import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store, persistor } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './tailwind-input.css';
import { BrowserRouter } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.js';
import { PersistGate } from 'redux-persist/integration/react';
import { NetworkProvider } from './components/NetworkProvider.js';

// ✅ No room/price fetches here — location is not known yet.
// All location-dependent data is fetched in Login.js (on login)
// and in App.js useEffect (on page refresh).

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate persistor={persistor}>
        <NetworkProvider>
          <App />
        </NetworkProvider>
      </PersistGate>
    </BrowserRouter>
  </Provider>
);

reportWebVitals();